import React from "react";
import "./SharedStyles.scss";

interface IProps {
  vertical?: boolean;
  /** Linia zanikająca na końcach, do lekkiego podziału w kartach. */
  soft?: boolean;
}

const EADivider: React.FC<IProps> = ({ vertical = false, soft = false }) => {
  return (
    <div
      className={["divider", vertical ? "divider-vertical" : "", soft ? "divider--soft" : ""].filter(Boolean).join(" ")}
      aria-hidden="true"
    />
  );
};

export default EADivider;
